import { Component, OnInit, TemplateRef, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal/index';

@Component({
  selector: 'app-template-notificacao',
  templateUrl: './template-notificacao.component.html',
  styleUrls: ['./template-notificacao.component.scss']
})
export class TemplateNotificacaoComponent implements OnInit {

  public templateUrl: string;

  constructor(
    protected dialogRef: MatDialogRef<ComponentType<any> | TemplateRef<any>>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { 
    this.templateUrl = data.url;
    document.querySelector('.mat-dialog-container')
      .addEventListener('mouseleave', () => this.dialogRef.close());
  }

  ngOnInit() {
    
  }
}
